import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  SlSelect,
  SlOption,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import YearCalendar from "../../shared/YearlyCalendar";
import API from "../../services/api";
import TableLoader from "../../shared/TableLoader";
import * as XLSX from 'xlsx'
import { toLakhs,getBrandOptions } from "../../utils/constants";
import ScrollContainer from "react-indiana-drag-scroll";

function PenetrationVsNewspaper() {
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [newsPapers, setNewsPapers] = useState([]);
  const selectedYear = useSelector((state) => state.Head.selectedYear);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const year = new Date(selectedYear).getFullYear() % 100;
  const [lastYearData, setLastYearData] = useState([]);
  const [thisYearData, setThisYearData] = useState([]);
  const [thisYearDataOriginal,setOriginalData]=useState([]);
  const [thisYearBothCounts,setBothCount]=useState([]);

  const [selectedType, setSelectedType] = useState("all");
  const [userType, setUserType] = useState(-1);
  const getdownloadData = () => {
    setDownloadLoader(true);
    try {
      const tableData = [
        ["Revenues in Lakhs", `${selectedNewspaper} Data Dec${year - 2}-Nov${year - 1}`,"","", 
         `W2N Data Dec${year - 2}-Nov${year - 1}`,"","", `W2N Data Dec${year-1}-Nov${year}`,"",""],
        ["","No. of Clients", "No. of Insertions", "Revenues", "No. of Clients", "No. of Insertions", "Revenues", "No. of Clients", "No. of Insertions", "Revenues"],
        ["W2N Total", 
         "", "", "", 
         lastYearData?.way2news_counts?.total_counts + lastYearData?.both_counts?.total_counts,
         lastYearData?.way2news_counts?.total_insertions + lastYearData?.both_counts?.total_way2news_insertions,
         toLakhs(lastYearData?.way2news_counts?.total_revenue + lastYearData?.both_counts?.total_way2news_revenue),
         thisYearDataOriginal?.total_counts + thisYearBothCounts?.total_counts, 
         thisYearDataOriginal?.total_insertions + thisYearBothCounts?.total_way2news_insertions,
         toLakhs(thisYearDataOriginal?.total_revenue + thisYearBothCounts?.total_way2news_revenue)],
        ["Exclusive W2N, No " + selectedNewspaper,"","","",
         lastYearData?.way2news_counts?.total_counts,
         lastYearData?.way2news_counts?.total_insertions,
         toLakhs(lastYearData?.way2news_counts?.total_revenue),
         thisYearDataOriginal?.total_counts,
         thisYearDataOriginal?.total_insertions,
         toLakhs(thisYearDataOriginal?.total_revenue)],
        ["Both W2N and " + selectedNewspaper,
         lastYearData?.both_counts?.total_counts,
         lastYearData?.both_counts?.total_newspaper_insertions,
         toLakhs((lastYearData?.both_counts?.total_newspaper_revenue)),
         lastYearData?.both_counts?.total_counts,
         lastYearData?.both_counts?.total_way2news_insertions,
         toLakhs((lastYearData?.both_counts?.total_way2news_revenue)),
         thisYearBothCounts?.total_counts,
         thisYearBothCounts?.total_way2news_insertions,
         toLakhs(thisYearBothCounts?.total_way2news_revenue)],
        ["Only " + selectedNewspaper + ", no W2N",
         lastYearData?.newspaper_counts?.total_counts,
         lastYearData?.newspaper_counts?.total_insertions,
         toLakhs(lastYearData?.newspaper_counts?.total_revenue),
         "", "", "","","",""],
        [selectedNewspaper + " Total",
         lastYearData?.newspaper_counts?.total_counts + lastYearData?.both_counts?.total_counts,
         lastYearData?.newspaper_counts?.total_insertions + lastYearData?.both_counts?.total_newspaper_insertions,
         toLakhs(lastYearData?.newspaper_counts?.total_revenue + lastYearData?.both_counts?.total_newspaper_revenue),
         "", "", "","","",""]
      ];
      let merges = []
      merges.push({s:{r:0, c:0}, e:{r:1,c:0}})
      merges.push({s:{r:0,c:1},e:{r:0,c:3}})
      merges.push({s:{r:0,c:4},e:{r:0,c:6}})
      merges.push({s:{r:0,c:7},e:{r:0,c:9}})
      merges.push({s:{r:2,c:1}, e:{r:3,c:3}})
      merges.push({s:{r:5,c:4}, e:{r:6, c:9}})

      // Create a worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(tableData);
      worksheet['!merges'] = merges
      // Create a workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Revenue Data");
  
      // Write the file
      XLSX.writeFile(workbook, `Pentrationvs${selectedNewspaper}.xlsx`);
    } catch (error) {
      console.error(error);
    } finally {
      setDownloadLoader(false);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/plansummary/penetration",
        method: "POST",
        responseType: "json",
        data: {
          year: selectedYear,
          newsPaper: selectedNewspaper,
          type: selectedType,
        },
      });
      if (res.code === 200) {
        setThisYearData(res.data?.this_year);
        setLastYearData(res.data?.last_year);
        setOriginalData(res.data?.this_year_original);
        setBothCount(res.data?.this_year_both_counts);
        setUserType(res.data?.userType)
        if(res.data.userType !== -1){
          setSelectedType(`${res.data.userType}`)
        }
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  const fetchNewspapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewsPapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchNewspapers();
  }, []);

  useEffect(() => {
    fetchData();
  }, [selectedNewspaper, selectedYear,selectedType]);

  return (
    <>
      <div className="d-flex gap-3 justify-end items-center my-2">
      <SlSelect size="small" value={selectedType} label="Team" onSlChange={(e) => {setSelectedType(e.target.value)}}>
          {userType === -1 ? <SlOption value='all'>All</SlOption> : null}
          {getBrandOptions(userType, localStorage.getItem('email'))?.map((type) => (
            <SlOption key={type.value} value={type.value}>{type.label}</SlOption>
          ))}
        </SlSelect>
        <SlSelect
          placeholder="NewsPaper"
          value={selectedNewspaper}
          onSlChange={(e) => setSelectedNewspaper(e.target.value)}
        >
          {newsPapers.map((item) => (
            <SlOption key={item.name} value={item.name}>
              {item.name}
            </SlOption>
          ))}
        </SlSelect>
        <YearCalendar startYear={2023} endYear={2100}></YearCalendar>
        {downloadLoader ? (
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        ) : (
          <div
            className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
            onClick={getdownloadData}
          >
            <sl-tooltip content="Download" placement="top">
              <SlIcon library="lucide" name="download" />
            </sl-tooltip>
          </div>
        )}
      </div>
      <ScrollContainer>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th rowSpan={2}>Revenues in Lakhs</th>
            <th colSpan={3}>
              {selectedNewspaper} Data Dec{year - 2}-Nov{year - 1}
            </th>
            <th colSpan={3}>
              W2N Data Dec{year - 2}-Nov{year - 1}
            </th>
            <th colSpan={3}>
              W2N Data Dec{year-1}-Nov{year}
            </th>
          </tr>
          <tr>
            {Array.from({ length: 3 }).map((_, index) => (
              <>
                <th>No. of Clients</th>
                <th>No. of Insertions</th>
                <th>Revenues</th>
              </>
            ))}
          </tr>
        </thead>
       {!loader ? <tbody>
          <tr>
            <th>W2N Total</th>
            <td colSpan={3} rowSpan={2} className="!bg-zinc-300"></td>
            <td>{lastYearData?.way2news_counts?.total_counts+lastYearData?.both_counts?.total_counts}</td>
            <td>{lastYearData?.way2news_counts?.total_insertions+lastYearData?.both_counts?.total_way2news_insertions}</td>
            <td>{toLakhs(lastYearData?.way2news_counts?.total_revenue+lastYearData?.both_counts?.total_way2news_revenue)}</td>
            <td>{thisYearDataOriginal.total_counts+thisYearBothCounts?.total_counts}</td>
            <td>{thisYearDataOriginal.total_insertions+thisYearBothCounts?.total_way2news_insertions}</td>
            <td>{toLakhs(thisYearDataOriginal.total_revenue+thisYearBothCounts?.total_way2news_revenue)}</td>
          </tr>
          <tr>
            <th>Exclusive W2N, No {selectedNewspaper}</th>
            <td>{lastYearData?.way2news_counts?.total_counts}</td>
            <td>{lastYearData?.way2news_counts?.total_insertions}</td>
            <td>{toLakhs(lastYearData?.way2news_counts?.total_revenue)}</td>
            <td>{thisYearDataOriginal.total_counts}</td>
            <td>{thisYearDataOriginal.total_insertions}</td>
            <td>{toLakhs(thisYearDataOriginal.total_revenue)}</td>
          </tr>
          <tr>
            <th> Both W2N and {selectedNewspaper}</th>
            <td>{lastYearData?.both_counts?.total_counts}</td>
            <td>{lastYearData?.both_counts?.total_newspaper_insertions}</td>
            <td>{toLakhs(lastYearData?.both_counts?.total_newspaper_revenue)}</td>
            <td>{lastYearData?.both_counts?.total_counts}</td>
            <td>{lastYearData?.both_counts?.total_way2news_insertions}</td>
            <td>{toLakhs(lastYearData?.both_counts?.total_way2news_revenue)}</td>
            <td>{thisYearBothCounts?.total_counts}</td>
            <td>{thisYearBothCounts?.total_way2news_insertions}</td>
            <td>{toLakhs(thisYearBothCounts?.total_way2news_revenue)}</td>
          </tr>
          <tr>
            <th>Only {selectedNewspaper}, no W2N</th>
             <td>{lastYearData?.newspaper_counts?.total_counts}</td>
            <td>{lastYearData?.newspaper_counts?.total_insertions}</td>
            <td>{toLakhs(lastYearData?.newspaper_counts?.total_revenue)}</td>
            <td colSpan={6} rowSpan={2} className="!bg-zinc-300"></td>
          </tr>
          <tr>
            <th>{selectedNewspaper} Total</th>
            <td>{lastYearData?.newspaper_counts?.total_counts+lastYearData?.both_counts?.total_counts}</td>
            <td>{lastYearData?.newspaper_counts?.total_insertions+lastYearData?.both_counts?.total_newspaper_insertions}</td>
            <td>{toLakhs(lastYearData?.newspaper_counts?.total_revenue+lastYearData?.both_counts?.total_newspaper_revenue)}</td>
          </tr>
        </tbody> : <TableLoader colspan={10}/>}
      </table>
      </ScrollContainer>
    </>
  );
}

export default PenetrationVsNewspaper;
